import { jkLoomShadow } from './jkLoomTokens';

const cardShadow = jkLoomShadow.floating;
const cardShadowDark = jkLoomShadow.floatingDark;

const shadows = [
  'none',
  '0px 1px 2px rgba(46, 0, 82, 0.06)',
  '0px 2px 4px rgba(46, 0, 82, 0.08)',
  cardShadow,
  cardShadow,
  cardShadow,
  cardShadow,
  cardShadow,
  cardShadow,
  cardShadow,
  cardShadow,
  cardShadow,
  cardShadow,
  cardShadow,
  cardShadow,
  cardShadow,
  cardShadow,
  cardShadow,
  cardShadow,
  cardShadow,
  cardShadow,
  cardShadow,
  cardShadow,
  cardShadow,
  cardShadow,
];

const darkshadows = [
  'none',
  '0px 1px 2px rgba(0, 0, 0, 0.4)',
  '0px 2px 6px rgba(0, 0, 0, 0.45)',
  cardShadowDark,
  cardShadowDark,
  cardShadowDark,
  cardShadowDark,
  cardShadowDark,
  cardShadowDark,
  `${cardShadowDark}, ${jkLoomShadow.glowDark}`,
  cardShadowDark,
  cardShadowDark,
  cardShadowDark,
  cardShadowDark,
  cardShadowDark,
  cardShadowDark,
  cardShadowDark,
  cardShadowDark,
  cardShadowDark,
  cardShadowDark,
  cardShadowDark,
  cardShadowDark,
  cardShadowDark,
  cardShadowDark,
  cardShadowDark,
];

export { shadows, darkshadows };
